import React, { useContext, useEffect, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import InputDefault from '../../../components/InputDefault';
import InputDate from '../../../components/InputDate';
import Select from '../../../components/Select';
import RadioButtonForm from '../../../components/RadioButtonForm';
import InputPhone from '../../../components/InputPhone';
import { SecondaryLargeButton } from '../../../components/Buttons/styles';
import FormTemplate from '../../../components/FormTemplate';
import Loader from '../../../components/Loader';
import { dataSolicitationSteps, identificationType } from '../../../helpers/enum';
import { Form, FormFooter, FormRow, FormRowInvisible } from '../../../components/FormTemplate/styles';
import { default as DataSolicitationTypes } from '../../../store/DataSolicitation/types';
import { DataSolicitationContext } from '../../../store/index';
import { getEducational } from '../../../services/educational';
import { useHistory, useLocation } from 'react-router-dom';
import { maritalStatus } from '../../../helpers/enum';
import { formatPhone } from '../../../helpers/string';
import { getSolicitaionDataByCreditId, saveAditionalData, saveBasicData, saveComplementData } from '../../../services/dataSolicitation';
import { isPricing } from '../../../services/tasas';
import { calculateDate } from '../../../helpers/date';
import { getExtracts } from '../../../services/extract';

import { currencyMoney } from '../../../config/currency';
import { getAllCities, getStates, getEthnicGroup} from '../../../services/states';
import SearchField from '../../../components/SearchField';
import ModalActionAddress from '../../../components/ModalActionAddress';
import { getCities } from '../../../services/cities';
import { ComplementDataSubtitleForm } from '../ComplementData/styles';
import { handleChangeIdentification } from '../../../helpers/price';

const OldBasicDataPage = ({ setActiveStep, setLastStep }) => {
  const location = useLocation();
  const history = useHistory();
  const { dataSolicitation, setDataSolicitation } = useContext(DataSolicitationContext);
  const { control, register, errors, setValue, handleSubmit, clearErrors, watch } = useForm({ defaultValues: dataSolicitation.basicData });
  const [educationalLevel, setEducationalLevel] = useState([]);
  const [gender, setGender] = useState('');
  const [documentType, setDocumentType] = useState('');
  const [showEducationalLevel, setShowEducationalLevel] = useState(false);
  const [showMaritalStatus, setShowMaritalStatus] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const fields = watch();
  const [showPaises, setShowPaises] = useState(false);
  const [countries, setCountries] = useState([{ id: 1, nombre: "Colombia" }, { id: 2, nombre: "Otro país" }]);
  const [anotherCountry, setAnotherCountry] = useState(false);
  const [cities, setCities] = useState([]);
  const [showCities, setShowCities] = useState(false);
  const [filteredCities, setFilteredCities] = useState([]);
  const [showModalAddress, setShowModalAddress] = useState(false);
  const [showExtraState, setShowExtraState] = useState(false);
  const [filteredExtraStates, setFilteredExtraStates] = useState([]);
  const [extraCities, setExtraCities] = useState([]);
  const [showExtraCity, setShowExtraCity] = useState(false);
  const [states, setStates] = useState([]);
  const [filteredExtraCities, setFilteredExtraCities] = useState([]);
  const [showState, setShowState] = useState(false);
  const [filteredStates, setFilteredStates] = useState([]);
  const [showCityResidence, setShowCityResidence] = useState(false);
  const [filteredCitiesResidence, setFilteredCitiesResidence] = useState([]);
  const [citiesResidence, setCitiesResidence] = useState([]);
  const [grupoEtnico, setGrupoEtnico] = useState([]);
  const [buscarGrupoEtnico, setBuscarGrupoEtnico] = useState([]);
  const [showGrupoEtnico, setShowGrupoEtnico] = useState(false);


  async function initializeStateComponent() {
    try {
      const response = await getAllCities();
      response.data.forEach(function (objeto) {
        var id = objeto.id.split('>')[1];
        objeto.nombre = objeto.nombre + ' (' + id + ')';
      });
      const states = await getStates();
      setStates(states.data);
      setCities(response.data);
      if (response.data.find(item => item.nombre === dataSolicitation.solicitation.cliente.lugarNacimiento)) {
        selectCity(response.data.find(item => item.nombre === dataSolicitation.solicitation.cliente.lugarNacimiento))
      }
      await autoCompleteData();
      await autoCompleteData();
      if (response.data.find(item => item.nombre === dataSolicitation.solicitation.cliente.lugarNacimiento)) {
        selectCity(response.data.find(item => item.nombre === dataSolicitation.solicitation.cliente.lugarNacimiento))
      }
      const fetchBuscarGrupoEtnico = async () => {
        try {
          const response = await getEthnicGroup();
          console.log("response", response)
          setBuscarGrupoEtnico(response.data);
          console.log("Preseleccionado", dataSolicitation.basicData.grupoEtnico.id)
          if(!dataSolicitation.basicData.grupoEtnico.id){
            if (response.data.find(item => item.id === dataSolicitation.basicData.grupoEtnico)) {
              selectEthnicGroup(response.data.find(item => item.id === dataSolicitation.basicData.grupoEtnico))
            }
          }else{
            selectEthnicGroup(dataSolicitation.basicData.grupoEtnico);
          }
        } catch (error) {
          console.error('Error fetching ethnicities:', error);
        }
      };
      fetchBuscarGrupoEtnico();
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error)
      console.log(error.response)
    }
  }

  function searchInState(e) {
    setShowState(true);
    setShowCityResidence(false);
    const filtered = states.filter(city => city.nombre.toLowerCase().indexOf(e.target.value.toLocaleLowerCase()) > -1);
    setFilteredStates(filtered);
  }

  function setSelectedCity(city) {
    setValue('ciudad', city.nombre);
    setDataSolicitation({
      type: DataSolicitationTypes.SET_ADITIONAL_DATA_SELECTED_CITY,
      city
    });

    setShowCityResidence(false);
  }

  function setSelectedCityResidence(city) {
    setValue('ciudad', city?.nombre);
    setDataSolicitation({
      type: DataSolicitationTypes.SET_ADITIONAL_DATA_SELECTED_CITY,
      city
    });

    setShowCityResidence(false);
  }

  function autoCompleteData(data) {
    selectEducationalLevel(dataSolicitation.basicData.nivelEducativo);
    //setValue('celular', formatPhone(dataSolicitation.solicitation.cliente.celular));
    selectMaritalStatus(maritalStatus.filter(ms => ms.id === dataSolicitation.basicData.estadoCivil?.id || dataSolicitation.lastCredit.estadoCivil)[0]);
    setValue('profesion', dataSolicitation.credit.profesion || dataSolicitation.lastCredit.profesion);
    //setValue('paisNacimiento', dataSolicitation.client.paisNacimiento);
    //setValue('lugarNacimiento', dataSolicitation.client.lugarNacimiento);
    //setValue('nacionalidad', dataSolicitation.client.nacionalidad); Se comenta para que siempre sea por defecto Colombiana
    setValue('nacionalidad', 'Colombiana');
    setGenderRadioChecked({ value: dataSolicitation.client.genero });
    if (dataSolicitation.basicData.genero) {
      setValue("genero", dataSolicitation.basicData.genero)
    }
    selectPaises({ id: 1, nombre: "Colombia" });
    setValue('pagaduria', dataSolicitation.complementData.pagaduria.nombre)
    setValue('ciudad', dataSolicitation.complementData.ciudad.nombre)
    setValue('departamento', dataSolicitation.aditionalData.departamento.nombre)
    setValue('ciudad', dataSolicitation.aditionalData.ciudad.nombre)
    setValue('extraDepartamento', dataSolicitation.aditionalData.extraDepartamento.nombre)
    setValue('extraCiudad', dataSolicitation.aditionalData.extraCiudad.nombre)
/*     setValue('grupoEtnico', dataSolicitation.basicData.grupoEtnico.nombre) */
  }

  function selectEducationalLevel(educationalLevel) {
    setValue("educationalLevel", educationalLevel);
    clearErrors("educationalLevel", {});

    setDataSolicitation({
      type: DataSolicitationTypes.SET_EDUCATIONAL_LEVEL,
      educationalLevel: educationalLevel
    })
  }

  function handleCalculateDate() {
    let years = calculateDate(fields.fechaNacimiento);

    setValue("edad", years);
    setDataSolicitation({
      type: DataSolicitationTypes.SET_EDAD,
      edad: years
    })
  }



  function selectPaises(pais) {
    if (pais.id == 2) {
      setAnotherCountry(true);
      setValue("paisNacimiento2", pais?.nombre);
      clearErrors("paisNacimiento2", {});
      setValue('paisNacimiento', '');
      setValue('nacionalidad', '');
      setValue('lugarNacimiento', '');
    } else {
      setAnotherCountry(false);
      setValue('paisNacimiento2', pais?.nombre);
      clearErrors("paisNacimiento2", {});
      setValue('paisNacimiento', pais?.nombre);
      setValue('nacionalidad', 'Colombiana');
      if (cities.length > 1) {
        selectCity(cities.find(item => item.nombre === dataSolicitation.solicitation.cliente?.lugarNacimiento))
      }
    }
    setDataSolicitation({
      type: DataSolicitationTypes.SET_PAIS_NACIMIENTO,
      paisNacimiento2: pais.nombre
    })

  }

  function selectMaritalStatus(estadoCivil) {
    setValue("estadoCivil", estadoCivil);
    clearErrors("estadoCivil", {});
    setDataSolicitation({
      type: DataSolicitationTypes.SET_BASIC_DATA_MARITAL_STATUS,
      estadoCivil: estadoCivil
    })
  }

  function setGenderRadioChecked(genero) {
    setGender(genero.value);
  }

  function searchInCities(e) {
    setShowCities(true);
    let filtered = cities.filter(city => city.nombre.toLowerCase().indexOf(e.target.value.toLocaleLowerCase()) > -1);
    setFilteredCities(filtered);
  }

  function searchInCitiesResidence(e) {
    setShowCityResidence(true);
    let filtered = citiesResidence.filter(city => city.nombre.toLowerCase().indexOf(e.target.value.toLocaleLowerCase()) > -1);
    setFilteredCitiesResidence(filtered);
  }

  async function selectCity(city) {
    setValue('lugarNacimiento', city?.nombre);
    setValue('lugarNacimiento2', city?.nombre);
    setDataSolicitation({
      type: DataSolicitationTypes.SET_SELECTED_CITY,
      lugarNacimiento2: city?.nombre
    })

    setShowCities(false);
  }

  async function setCompleteStep(formData) {
    try {
      setIsLoading(true);
      console.log("formDAta",formData)
      console.log("data solicitation", dataSolicitation.basicData.grupoEtnico.id)
      const data = {
        idCredito: location.idCredit,
        cliente: {
          paisNacimiento: formData.paisNacimiento,
          lugarNacimiento: formData.lugarNacimiento,
          nacionalidad: formData.nacionalidad,
          genero: gender,
          grupoEtnico: dataSolicitation.basicData.grupoEtnico.id,
        },
        credito: {
          estadoCivil: dataSolicitation.basicData.estadoCivil.id,
          profesion: formData.profesion
        }
      }
      setDataSolicitation({
        type: DataSolicitationTypes.SET_BASIC_DATA,
        basicData: {
          ...dataSolicitation.basicData,
          nombres: dataSolicitation.basicData.nombres,
          fechaNacimiento: dataSolicitation.basicData.fechaNacimiento,
          edadCliente: dataSolicitation.basicData.edadCliente,
          tipoIdentificacion: dataSolicitation.basicData.tipoIdentificacion,
          identificacion: dataSolicitation.basicData.identificacion,
          fechaExpedicionDocumento: dataSolicitation.basicData.fechaExpedicionDocumento,
          ciudadExpedicionIdentificacion: dataSolicitation.basicData.ciudadExpedicionIdentificacion,
          nivelEducativo: dataSolicitation.basicData.nivelEducativo,
          celular: dataSolicitation.basicData.celular,
          email: dataSolicitation.basicData.email,
          estadoCivil: dataSolicitation.basicData.estadoCivil,
          paisNacimiento: formData.paisNacimiento,
          lugarNacimiento: formData.lugarNacimiento,
          nacionalidad: formData.nacionalidad,
          profesion: formData.profesion,
          grupoEtnico: dataSolicitation.basicData.grupoEtnico
        }
      })
      await saveBasicData(data, location.idCredit);

      const dataa = {
        idCredito: location.idCredit,
        cliente: {
          direcciones: [
            {
              tipo: "7",
              direccion: formData.direccion,
              barrio: formData.barrio,
              departamento: dataSolicitation.aditionalData.departamento.id,
              ciudad: dataSolicitation.aditionalData.ciudad.id
            },
            {
              tipo: "9",
              direccion: (dataSolicitation.aditionalData.correspondencia.value != 'residencia') ? formData.extraDireccion : formData.direccion,
              barrio: (dataSolicitation.aditionalData.correspondencia.value != 'residencia') ? formData.extraBarrio : formData.barrio,
              departamento: (dataSolicitation.aditionalData.correspondencia.value != 'residencia') ? dataSolicitation.aditionalData.extraDepartamento.id : dataSolicitation.aditionalData.departamento.id,
              ciudad: (dataSolicitation.aditionalData.correspondencia.value != 'residencia') ? dataSolicitation.aditionalData.extraCiudad.id : dataSolicitation.aditionalData.ciudad.id
            }
          ]
        },
        credito: {
          mesesResidenciaActual: 0,
          numeroHijos: formData.numeroHijos,
          personasACargo: formData.personasACargo,
          tieneVehiculo: dataSolicitation.aditionalData.tieneVehiculo.value
        }
      }

      setDataSolicitation({
        type: DataSolicitationTypes.SET_ADITIONAL_DATA,
        aditionalData: {
          ...dataSolicitation.aditionalData,
          nombres: dataSolicitation.aditionalData.nombres,
          fechaNacimiento: dataSolicitation.aditionalData.fechaNacimiento,
          edadCliente: dataSolicitation.aditionalData.edadCliente,
          tipoIdentificacion: dataSolicitation.aditionalData.tipoIdentificacion,
          identificacion: dataSolicitation.aditionalData.identificacion,
          fechaExpedicionDocumento: dataSolicitation.aditionalData.fechaExpedicionDocumento,
          ciudadExpedicionIdentificacion: dataSolicitation.aditionalData.ciudadExpedicionIdentificacion,
          nivelEducativo:dataSolicitation.aditionalData.nivelEducativo,
          celular: dataSolicitation.aditionalData.celular,
          email: dataSolicitation.aditionalData.email,
          direccion: fields.direccion,
          barrio: fields.barrio,
          extraDireccion: (dataSolicitation.aditionalData.correspondencia.value != 'residencia') ? fields.extraDireccion : formData.direccion,
          extraBarrio: (dataSolicitation.aditionalData.correspondencia.value != 'residencia') ? fields.extraBarrio : formData.barrio,
          mesesResidenciaActual: 0,
          numeroHijos: fields.numeroHijos,
          personasACargo: fields.personasACargo,
          grupoEtnico: formData.grupoEtnico
        }
      })
      await saveAditionalData(dataa, location.idCredit);

      if(dataSolicitation.basicData.estadoCivil?.id == 'CASADO'){
        const dataa = {
          idCredito: location.idCredit,
          nombre1: fields.nombre1,
          nombre2: fields.nombre2,
          apellido1: fields.apellido1,
          apellido2: fields.apellido2,
          idTipo: dataSolicitation.complementData.idTipo,
          identificacion: fields.identificacion1,
          email: "",
          telefonoResidencia: "",
          lugarNacimiento: "",
          actividadEconomica: null,
          empresaTrabajo: "",
          cargo: "",
          idDepartamentoTrabajo: "CO>Indefinido",
          idCiudadTrabajo: "CO>Indefinido>Indefinido",
          telefonoTrabajo: "",
          extensionTrabajo: "",
          telefonoCelular: fields.celular1?.replaceAll(' ', ''),
        }
  
        await setDataSolicitation({
          type: DataSolicitationTypes.SET_COMPLEMENT_DATA,
          complementData: {
            nombre1: fields.nombre1,
            nombre2: fields.nombre2,
            apellido1: fields.apellido1,
            apellido2: fields.apellido2,
            idTipo: dataSolicitation.complementData.idTipo,
            identificacion: fields.identificacion1,
            email: "",
            telefonoResidencia: "",
            lugarNacimiento: "",
            actividad: "",
            empresaTrabajo: "",
            cargo: "",
            pagaduria: "",
            ciudad: "",
            telefonoTrabajo: "",
            extensionTrabajo: "",
            telefonoCelular: fields.celular1?.replaceAll(' ', ''),     
          }
        })
        await saveComplementData(dataa);
      }
      setIsLoading(false);
      setActiveStep(dataSolicitationSteps.WORK_DATA)
      setLastStep(dataSolicitationSteps.BASIC_DATA);
    } catch (error) {
      console.log(error.response);
      setIsLoading(false);
    }
  }

  async function setSelectedState(state) {
    try {
      setIsLoading(true);
      console.log(state);
      const cities = await getCities(state.id);
      setCitiesResidence(cities.data);

      setValue('departamento', state.nombre);
      setDataSolicitation({
        type: DataSolicitationTypes.SET_ADITIONAL_DATA_SELECTED_STATE,
        state
      });

      if(fields.ciudad) {
        setValue('ciudad', '');
        setDataSolicitation({
          type: DataSolicitationTypes.SET_SELECTED_CITY,
          city: {}
        });
      }

      setIsLoading(false);
      setShowState(false);
      setShowCityResidence(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error.response)
    }
  }

  useEffect(() => {
    if (!location.idCredit) {
      return history.push('/admin/dashboard');
    }

    initializeStateComponent();
  }, [])

  function selectCorrespondence(correspondence) {
    setValue("correspondencia", correspondence);

    setDataSolicitation({
      type: DataSolicitationTypes.SET_CORRESPONDENCE,
      correspondencia: correspondence
    })
  }

  async function setSelectedExtraState(state) {
    try {
      setIsLoading(true);
      const cities = await getCities(state.id);
      setExtraCities(cities.data);

      setValue('extraDepartamento', state.nombre);
      setDataSolicitation({
        type: DataSolicitationTypes.SET_SELECTED_EXTRA_STATE,
        state
      });

      if(fields.extraCiudad) {
        setValue('extraCiudad', '');
        setDataSolicitation({
          type: DataSolicitationTypes.SET_SELECTED_EXTRA_CITY,
          city: {}
        });
      }

      setIsLoading(false);
      setShowExtraState(false);
      setShowExtraCity(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error.response)
    }
  }

  function searchInExtraState(e) {
    setShowExtraState(true);
    setShowExtraCity(false);
    const filtered = states.filter(city => city.nombre.toLowerCase().indexOf(e.target.value.toLocaleLowerCase()) > -1);
    setFilteredExtraStates(filtered);
  }

  function setSelectedExtraCity(city) {
    setValue('extraCiudad', city.nombre);
    setDataSolicitation({
      type: DataSolicitationTypes.SET_SELECTED_EXTRA_CITY,
      city
    });

    setShowExtraCity(false);
  }

  function searchInExtraCities(e) {
    setShowExtraCity(true);
    setShowExtraState(false);
    const filtered = extraCities.filter(city => city.nombre.toLowerCase().indexOf(e.target.value.toLocaleLowerCase()) > -1);
    setFilteredExtraCities(filtered);
  }

  function selectDocumentType(radio) {
    setDataSolicitation({
      type: DataSolicitationTypes.SET_COMPLEMENT_DATA_IDENTIFICATION_TYPE,
      idTipo: radio.value
    })
  }

  function onChangeIdentification(e) {
    if(dataSolicitation.complementData.idTipo === 'CE') {
      setValue('identificacion', e.target.value)
    } else {
      setValue('identificacion', handleChangeIdentification(e.target.value))
    }
  }

  const selectEthnicGroup = (etnico) => {
    console.log('Selected ethnicity:', etnico);
    setValue("grupoEtnico", etnico);
    clearErrors("grupoEtnico", {});
    setDataSolicitation({
      type: DataSolicitationTypes.SET_SELECT_ETHNIC_GROUP,
      grupoEtnico: etnico,
    });
    setGrupoEtnico(etnico);
  };
  return (
    <FormTemplate
      idForm="basic-data-step-page"
      activeStep="1/4"
      stepLabel="Datos complementarios">
      <Form onSubmit={handleSubmit(setCompleteStep)} id="form">
        <FormRow col="2">
          <Select
            setShow={setShowPaises}
            show={showPaises}
            defaultValue={dataSolicitation.solicitation.cliente.paisNacimiento2}
            setSelected={selectPaises}
            list={countries}
            placeholder="Seleccionar..."
            label="Pais de nacimiento"
            name="paisNacimiento2"
            id="paisNacimiento2"
            error={errors.paisNacimiento2}
            register={register({ required: "Este dato es obligatorio" })}
          />
          <Controller
            type="text"
            as={InputDefault}
            control={control}
            register={register({ required: "Este dato es obligatorio" })}
            label="Nacionalidad"
            name="nacionalidad"
            id="nacionalidad"
            error={errors.nacionalidad}
            value={dataSolicitation.solicitation.cliente.nacionalidad}
            readOnly={!anotherCountry}
          />
        </FormRow>
        <FormRow style={anotherCountry ? { display: 'grid' } : { display: 'none' }}>
          <Controller
            error={errors.paisNacimiento}
            type="text"
            as={InputDefault}
            control={control}
            label="Pais de nacimiento"
            name="paisNacimiento"
            id="paisNacimiento"
            value={dataSolicitation.solicitation.cliente.paisNacimiento}
            register={register({ required: "Este dato es obligatorio" })} />
        </FormRow>
        
        <FormRow col="2">
          {!anotherCountry &&
            <SearchField
              label="Ciudad de Nacimiento"
              name="lugarNacimiento2"
              id="lugarNacimiento2"
              show={showCities}
              list={filteredCities}
              defaultValue={dataSolicitation.solicitation.cliente.lugarNacimiento2}
              selectField={selectCity}
              searchInList={searchInCities}
              register={register({ required: "Este dato es obligatorio" })}
              placeholder="Buscar..."
              error={errors.lugarNacimiento2} />
           }
          
          <div style={anotherCountry ? { display: 'grid' } : { display: 'none' }}>
          <Controller
              type="text"
              as={InputDefault}
              control={control}
              error={errors.lugarNacimiento}
              register={register({ required: "Este dato es obligatorio" })}
              label="Ciudad de Nacimiento"
              name="lugarNacimiento"
              id="lugarNacimiento"
              value={dataSolicitation.solicitation.cliente.lugarNacimiento} />
          </div>

          {/*anotherCountry &&
            <Controller
              type="text"
              as={InputDefault}
              control={control}
              error={errors.lugarNacimiento}
              register={register({ required: "Este dato es obligatorio" })}
              label="Ciudad de Nacimiento"
              name="lugarNacimiento"
              id="lugarNacimiento"
              value={dataSolicitation.solicitation.cliente.lugarNacimiento} />
  */}
  
  <Select
  setShow={setShowGrupoEtnico}
  show={showGrupoEtnico}
  defaultValue={dataSolicitation.basicData?.grupoEtnico?.nombre}
  setSelected={selectEthnicGroup}
  list={buscarGrupoEtnico}
  placeholder="Seleccionar..."
  label="Grupo Étnico"
  name="grupoEtnico"
  id="grupoEtnico"
  error={errors.grupoEtnico}
  register={register({ required: "Este dato es obligatorio" })}
/>
        </FormRow>

        <FormRow col="2">
          <SearchField
            label="Departamento de Residencia"
            name="departamento"
            id="departamento"
            show={showState}
            list={filteredStates}
            defaultValue={dataSolicitation.aditionalData.departamento.nombre}
            selectField={setSelectedState}
            searchInList={searchInState}
            register={register({ required: "Este dato es obligatorio" })}
            placeholder="Buscar..."
            error={errors.departamento} />
          <SearchField
            label="Ciudad o Municipio de Residencia"
            name="ciudad"
            id="ciudad"
            show={showCityResidence}
            list={filteredCitiesResidence}
            defaultValue={dataSolicitation.aditionalData.ciudad.nombre}
            selectField={setSelectedCityResidence}
            searchInList={searchInCitiesResidence}
            register={register({ required: "Este dato es obligatorio" })}
            placeholder="Buscar..."
            error={errors.ciudad}
            disabled={!dataSolicitation.aditionalData.departamento.nombre} />
        </FormRow>

        <FormRow col="2">
          <Controller
            as={InputDefault}
            control={control}
            label="Dirección de residencia"
            name="direccion"
            id="direccion"
            error={errors.direccion}
            value={dataSolicitation.aditionalData.direccion}
            onClick={() => setShowModalAddress(true)}
            autoComplete="off"
            register={register({ required: "Este dato es obligatorio" })} />
          <Controller
            as={InputDefault}
            control={control}
            label="Barrio"
            name="barrio"
            id="barrio"
            error={errors.barrio}
            value={dataSolicitation.aditionalData.barrio} />
        </FormRow>

        <FormRow col="1">      
          <RadioButtonForm
            label="Correspondencia"
            setIdentificationRadioChecked={selectCorrespondence}
            selected={dataSolicitation.aditionalData.correspondencia.value}
            name="correspondencia"
            id="correspondencia"
            radios={[
              { label: 'Residencia', value: 'residencia' },
              { label: 'Oficina/Otro', value: 'oficina/otro' }
            ]} />
        </FormRow>
        <FormRow col="1">  
        <RadioButtonForm
            label="Género"
            setIdentificationRadioChecked={setGenderRadioChecked}
            selected={dataSolicitation.solicitation.cliente.genero === 'M' ? 'M' : 'F'}
            name="genero"
            id="genero"
            radios={[
              { label: 'M', value: 'M' },
              { label: 'F', value: 'F' }
            ]} />
</FormRow>
        {dataSolicitation.aditionalData.correspondencia.value != 'residencia' &&<>
        <FormRow col="2">
          <SearchField
            label="Depto. de correspondencia oficina / otro"
            name="extraDepartamento"
            id="extraDepartamento"
            show={showExtraState}
            list={filteredExtraStates}
            defaultValue={dataSolicitation.aditionalData.extraDepartamento.nombre}
            selectField={setSelectedExtraState}
            searchInList={searchInExtraState}
            register={register({ required: "Este dato es obligatorio" })}
            placeholder="Buscar..."
            error={errors.extraDepartamento} />
          <SearchField
            label="Ciudad de correspondencia oficina / otro"
            name="extraCiudad"
            id="extraCiudad"
            show={showExtraCity}
            list={filteredExtraCities}
            defaultValue={dataSolicitation.aditionalData.extraCiudad.nombre}
            selectField={setSelectedExtraCity}
            searchInList={searchInExtraCities}
            register={register({ required: "Este dato es obligatorio" })}
            placeholder="Buscar..."
            error={errors.extraCiudad}
            disabled={!dataSolicitation.aditionalData.extraDepartamento.nombre} />
        </FormRow>
        <FormRow col="2">
          <Controller
            as={InputDefault}
            control={control}
            label="Barrio correspondencia oficina / otro"
            name="extraBarrio"
            id="extraBarrio"
            error={errors.extraBarrio}
            value={dataSolicitation.aditionalData.extraBarrio}
            register={register({ required: "Este dato es obligatorio" })} />
          <Controller
            as={InputDefault}
            control={control}
            label="dirección correspondencia oficina / otro"
            name="extraDireccion"
            id="extraDireccion"
            error={errors.extraDireccion}
            value={dataSolicitation.aditionalData.extraDireccion}
            maxLength={50}
            register={register({
              required: {
                value: true,
                message: "Este dato es obligatorio y debe tener una longitud máxima de 50 caracteres."
              },
            })} />       
        </FormRow>     
        </>}

        <FormRow col="2">
          <Controller
            type="number"
            as={InputDefault}
            control={control}
            label="Numero de hijos"
            name="numeroHijos"
            id="numeroHijos"
            register={register({ required: "Este dato es obligatorio" })}
            error={errors.numeroHijos}
            value={dataSolicitation.aditionalData.numeroHijos} />
          <Controller
            type="number"
            as={InputDefault}
            control={control}
            label="Personas a cargo"
            name="personasACargo"
            id="personasACargo"
            register={register({ required: "Este dato es obligatorio" })}
            error={errors.personasACargo}
            value={dataSolicitation.aditionalData.personasACargo} />
        </FormRow>

        <FormRow>
          <Controller
            type="text"
            as={InputDefault}
            control={control}
            label="PROFESIÓN / OCUPACIÓN"
            name="profesion"
            id="profesion"
            error={errors.profesion}
            value={dataSolicitation.basicData.profesion}
            register={register({ required: "Este dato es obligatorio" })} />
          <Select
            setShow={setShowMaritalStatus}
            show={showMaritalStatus}
            defaultValue={dataSolicitation.basicData.estadoCivil?.nombre}
            setSelected={selectMaritalStatus}
            list={maritalStatus}
            placeholder="Seleccionar..."
            label="Estado civil"
            name="estadoCivil"
            id="estadoCivil"
            error={errors.estadoCivil}
            register={register({ required: "Este dato es obligatorio" })} />
        </FormRow>
        {dataSolicitation.basicData.estadoCivil?.id == 'CASADO' &&
        <>
        <ComplementDataSubtitleForm>Información del cónyuge</ComplementDataSubtitleForm>
          <FormRow col="2">
            <Controller
              as={InputDefault}
              control={control}
              label="Primer nombre"
              name="nombre1"
              id="nombre1"
              error={errors.nombre1}
              value={dataSolicitation.complementData.nombre1}
              register={register({ required: "Este dato es obligatorio" })} />
            <Controller
              as={InputDefault}
              control={control}
              label="Segundo nombre"
              name="nombre2"
              id="nombre2"
              error={errors.nombre2}
              value={dataSolicitation.complementData.nombre2}
              register={register} />
          </FormRow>
          <FormRow col="2">
            <Controller
              as={InputDefault}
              control={control}
              label="Primer apellido"
              name="apellido1"
              id="apellido1"
              error={errors.apellido1}
              value={dataSolicitation.complementData.apellido1}
              register={register({ required: "Este dato es obligatorio" })} />
            <Controller
              as={InputDefault}
              control={control}
              label="Segundo apellido"
              name="apellido2"
              id="apellido2"
              error={errors.apellido2}
              value={dataSolicitation.complementData.apellido2}
              register={register} />
          </FormRow>
          <FormRow col="2">
            <RadioButtonForm
              label="Tipo de documento"
              setIdentificationRadioChecked={selectDocumentType}
              selected={dataSolicitation.complementData.idTipo}
              name="idTipo"
              id="idTipo"
              radios={[
                { label: 'CC', value: 'CC' },
                { label: 'CE', value: 'CE' }
              ]} />
              <Controller
                name="identificacion"
                control={control}
                value={dataSolicitation.complementData.identificacion1}
                render={() => (
                  <InputDefault
                    name="identificacion1"
                    label="Número de documento de identidad"
                    register={register({ required: "Este dato es obligatorio" })}
                    id="identificacion1"
                    error={errors.identificacion}
                    maxLength={dataSolicitation.complementData.idTipo === 'CE' ? identificationType.ce.max : identificationType.cc.max}
                    minLength={dataSolicitation.complementData.idTipo === 'CE' ? identificationType.ce.min : identificationType.ce.min}
                    onChange={onChangeIdentification}
                  />
                )}
              />
          </FormRow>
          <FormRow col="2">
            <Controller
              as={InputPhone}
              control={control}
              label="Celular"
              name="celular1"
              error={errors.celular1}
              register={register({required: "Este dato es obligatorio"})}
              id="celular1"
              mask="999 999 99 99"
            />  
          </FormRow>
        
        </>
      }

        {/*
        <FormRow col="2">
          <Controller 
            error={errors.nombres}
            as={InputDefault}
            control={control}
            label="Nombres y apellidos"
            name="nombres"
            id="nombres"
            register={register}
            readOnly />
          <InputDate
            aria-required
            type="date"
            error={errors.fechaNacimiento}
            label="Fecha de nacimiento"
            name="fechaNacimiento"
            id="fechaNacimiento"
            register={register}
            onBlur={() => { }}
            readOnly />
        </FormRow>
        <FormRow col="2">
          <RadioButtonForm
            label="Tipo de documento"
            setIdentificationRadioChecked={() => { }}
            selected={dataSolicitation.solicitation.cliente.tipoIdentificacion === 'CC' ? 'CC' : 'CE'}
            name=""
            id=""
            radios={[
              { label: 'CC', value: 'CC' }
            ]}
            disabled />
          <Controller
            name="identificacion"
            control={control}
            render={() => (
              <InputDefault
                value={dataSolicitation.solicitation.cliente.identificacion}
                name="identificacion"
                label="Número de documento"
                id="identificacion"
                error={errors.identificacion}
                onChange={() => { }}
                readOnly
              />
            )}
          />
        </FormRow>
        <FormRow col="2">
          <InputDate
            aria-required
            type="date"
            label="Fecha de expedición"
            name="fechaExpedicionDocumento"
            id="fechaExpedicionDocumento"
            error={errors.fechaExpedicionDocumento}
            register={register}
            readOnly />
          <Select
            setShow={setShowPaises}
            show={showPaises}
            defaultValue={dataSolicitation.solicitation.cliente.paisNacimiento2}
            setSelected={selectPaises}
            list={countries}
            placeholder="Seleccionar..."
            label="Pais de nacimiento"
            name="paisNacimiento2"
            id="paisNacimiento2"
            error={errors.paisNacimiento2}
            register={register({ required: "Este dato es obligatorio" })}
          />
        </FormRow>
        {anotherCountry &&
          <></>
        }
        <FormRow style={anotherCountry ? { display: 'grid' } : { display: 'none' }}>
          <Controller
            error={errors.paisNacimiento}
            type="text"
            as={InputDefault}
            control={control}
            label="Pais de nacimiento"
            name="paisNacimiento"
            id="paisNacimiento"
            value={dataSolicitation.solicitation.cliente.paisNacimiento}
            register={register({ required: "Este dato es obligatorio" })} />
        </FormRow>
        <FormRow col="2">
          <div style={anotherCountry ? { display: 'none' } : { display: 'grid' }}>
            <SearchField
              label="Ciudad de Nacimiento"
              name="lugarNacimiento2"
              id="lugarNacimiento2"
              show={showCities}
              list={filteredCities}
              defaultValue={dataSolicitation.solicitation.cliente.lugarNacimiento2}
              selectField={selectCity}
              searchInList={searchInCities}
              register={register({ required: "Este dato es obligatorio" })}
              placeholder="Buscar..."
              error={errors.lugarNacimiento2} />
          </div>
          <div style={anotherCountry ? { display: 'grid' } : { display: 'none' }}>
            <Controller
              type="text"
              as={InputDefault}
              control={control}
              error={errors.lugarNacimiento}
              register={register({ required: "Este dato es obligatorio" })}
              label="Ciudad de Nacimiento"
              name="lugarNacimiento"
              id="lugarNacimiento"
              value={dataSolicitation.solicitation.cliente.lugarNacimiento} />
          </div>
          {/*!anotherCountry &&
            <SearchField
              label="Ciudad de Nacimiento"
              name="lugarNacimiento2"
              id="lugarNacimiento2"
              show={showCities}
              list={filteredCities}
              defaultValue={dataSolicitation.solicitation.cliente.lugarNacimiento2}
              selectField={selectCity}
              searchInList={searchInCities}
              register={register({ required: "Este dato es obligatorio" })}
              placeholder="Buscar..."
      error={errors.lugarNacimiento2} />*/}

          {/*anotherCountry &&
            <Controller
              type="text"
              as={InputDefault}
              control={control}
              error={errors.lugarNacimiento}
              register={register({ required: "Este dato es obligatorio" })}
              label="Ciudad de Nacimiento"
              name="lugarNacimiento"
              id="lugarNacimiento"
              value={dataSolicitation.solicitation.cliente.lugarNacimiento} />
    */}
    {/* 
        <FormRow>
          <Controller
            type="text"
            as={InputDefault}
            control={control}
            register={register({ required: "Este dato es obligatorio" })}
            label="Nacionalidad"
            name="nacionalidad"
            id="nacionalidad"
            error={errors.nacionalidad}
            value={dataSolicitation.solicitation.cliente.nacionalidad}
            readOnly={!anotherCountry}
          />
        </FormRow>
        <FormRow>
          <RadioButtonForm
            label="Genero"
            setIdentificationRadioChecked={setGenderRadioChecked}
            selected={dataSolicitation.solicitation.cliente.genero === 'M' ? 'M' : 'F'}
            name="genero"
            id="genero"
            radios={[
              { label: 'M', value: 'M' },
              { label: 'F', value: 'F' }
            ]} />
          <Select
            setShow={setShowMaritalStatus}
            show={showMaritalStatus}
            defaultValue={dataSolicitation.basicData.estadoCivil?.nombre}
            setSelected={selectMaritalStatus}
            list={maritalStatus}
            placeholder="Seleccionar..."
            label="Estado civil"
            name="estadoCivil"
            id="estadoCivil"
            error={errors.estadoCivil}
            register={register({ required: "Este dato es obligatorio" })} />
        </FormRow>
        <FormRow>
          <Controller
            type="text"
            as={InputDefault}
            control={control}
            label="PROFESIÓN / OCUPACIÓN"
            name="profesion"
            id="profesion"
            error={errors.profesion}
            value={dataSolicitation.basicData.profesion}
            register={register({ required: "Este dato es obligatorio" })} />
        </FormRow>
        {/*<FormRowInvisible>
          <Controller
            error={errors.paisNacimiento}
            type="text"
            as={InputDefault}
            control={control}
            label="Pais de nacimiento"
            name="paisNacimiento"
            id="paisNacimiento"
            value={dataSolicitation.solicitation.cliente.paisNacimiento}
            register={register({ required: "Este dato es obligatorio" })} />
          <Controller
            type="text"
            as={InputDefault}
            control={control}
            error={errors.lugarNacimiento}
            register={register({ required: "Este dato es obligatorio" })}
            label="Ciudad de Nacimiento"
            name="lugarNacimiento"
            id="lugarNacimiento"
            value={dataSolicitation.solicitation.cliente.lugarNacimiento} />
        </FormRowInvisible>*/ }
        <FormRowInvisible>
          <Controller
            type="number"
            as={InputDefault}
            control={control}
            label="Edad"
            name="edadCliente"
            id="edadCliente"
            error={errors.edadCliente}
            readOnly />
          <Controller
            type="text"
            as={InputDefault}
            control={control}
            label="Lugar de expedición"
            error={errors.ciudadExpedicionIdentificacion}
            name="ciudadExpedicionIdentificacion"
            id="ciudadExpedicionIdentificacion"
            readOnly />
          <Select
            setShow={setShowEducationalLevel}
            show={showEducationalLevel}
            defaultValue={dataSolicitation.basicData.educationalLevel?.nombre}
            setSelected={selectEducationalLevel}
            list={educationalLevel}
            placeholder="Seleccionar..."
            label="Nivel educativo"
            name="educationalLevel"
            id="educationalLevel"
            error={errors.educationalLevel}
            //register={register}
            disabled />
          <Controller
            as={InputPhone}
            control={control}
            label="Celular"
            name="celular"
            error={errors.celular}
            //register={register}
            id="celular"
            mask="999 999 99 99"
            readOnly />
          <Controller
            as={InputDefault}
            control={control}
            label="Correo Electrónico"
            name="email"
            //register={register}
            id="email"
            readOnly />
        </FormRowInvisible>
        <FormFooter justify="flex-end">
          <SecondaryLargeButton type="submit" id="submit">Siguiente </SecondaryLargeButton>
        </FormFooter>
        {isLoading && <Loader />}
      </Form>
      <ModalActionAddress
        open={showModalAddress}
        setShowModal={setShowModalAddress}
        actionFunctionDownButton={() => setShowModalAddress(false)}
        setValue={setValue}
        name="direccion"/>
    </FormTemplate>
  )
}

export default OldBasicDataPage
